import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const customerPortalRoutes = [
  {
    path: 'customer-portal',
    name: 'CustomerPortal',
    component: () => import('@/features/customerPortal/views/CustomerPortal.vue'),
    meta: {
      title: `${t('customer_portal')} | Pour Now`,
    },
  },
  {
    path: 'customer-portal/:slug',
    name: 'CustomerPortalCategory',
    component: () => import('@/features/customerPortal/views/CustomerPortalCategoryPosts.vue'),
    meta: {
      title: `${t('customer_portal')} | Pour Now`,
    },
  },
  {
    path: 'customer-portal/:slug/:id',
    name: 'CustomerPortalPost',
    component: () => import('@/features/customerPortal/views/CustomerPortalPostDetail.vue'),
    meta: {
      title: `${t('customer_portal')} | Pour Now`,
    },
  },
]
